/*eslint-disable */

import {
  bus
} from '../../main';
import createWebinar from './create-webinar-details';
import {
mapGetters,
} from 'vuex';
import moment from 'moment';
import pdfViewer from './pdf-viewer';
import updateWebinar from './update-webinar-details';

var $ = window.jQuery = require('jquery');
var interval;





export default {
name: 'webinar-list',
components: {
  'create-webinar': createWebinar,
  'edit-webinar' : updateWebinar,
  'pdf-viewer' : pdfViewer
},
props: [],
data () {
  return {
    userProfileDetails:{},
    curentDate: new Date(),
    fullCurrentDateFormatWithUtc:'',
    startTimerCheck:false,
    countDownMinutes:'',
    countDownSecond:'',
    counterText:'',
    speakerBioPoup:false,
    createWebinarPopup:false,
    updateWebinarPopup:false,
    updateWebinarId:'',
    webinarListDetails: {},
    speakerBioData:'',
    selfUserId:'',
    pdfViewerPopup:false,
    pdfViewerUrl:'',
    profileUpdateAlertPopup:false,
    pdfViewerFileName:''
  }
},
computed: {
  ...mapGetters([
    'selfUserInfoGetters',
    'getWebinarAllListGetters'
  ]),
  getUserDetailsInfo(){
    this.userProfileDetails = this.$store.getters.selfUserInfoGetters.data;
    return
  },
  getWebinarList() {
    this.webinarListDetails = this.$store.getters.getWebinarAllListGetters.data;
    return
  },
},
mounted () {
  if(localStorage.getItem('LoginedUserID')){
    this.selfUserId = localStorage.getItem('LoginedUserID')
  }
  this.getWebinarList
  this.getUserDetailsInfo
  bus.$on('createWebinarPopupBus', (data) => {
    this.createWebinarPopup = data;
  });
  bus.$on('updateWebinarPopupBus', (data) => {
    this.updateWebinarPopup = data;
  });
  bus.$on('pdfViewerPopupBus', (data) => {
    this.pdfViewerPopup = data;
  });
},
methods: {
  getEstimationTimeOfWebinar(joinStartTime, joinEndTime){
    var TimeCheckStart = moment(joinStartTime).format('MMMM Do YYYY HH:mm:ss')
    var TimeCheckEnd = moment(joinEndTime).format('MMMM Do YYYY HH:mm:ss')
    let startTime = moment(joinStartTime).format('HH:mm:ss');
    let endTime   = moment(joinEndTime).format('HH:mm:ss');
    // console.log(startTime,endTime, "Check The Estimation Time")
    // Defining start and end variables
    let start = moment(startTime, 'HH:mm:ss');
    let end   = moment(endTime, 'HH:mm:ss');
    // Getting the difference: hours (h), minutes (m) and seconds (s)
    let h  = end.diff(start, 'hours');
    let m  = end.diff(start, 'minutes') - (60 * h);
    let n  = m + (15);
    let s  = end.diff(start, 'ss') - (60 * 60 * h) - (60 * m);
    // Formating in hh:mm:ss (appends a left zero when num < 10)
    let hh = ('0' + h).slice(-2);
    let mm = ('0' + m).slice(-2);
    let mn = ('0' + n).slice(-2);
    let ss = ('0' + s).slice(-2);
    return `${mm} - ${mn}`;
  },
  userInfoAlertPopupOpenFun(){
    $('body').addClass('body_right_scroll_remove')
    this.profileUpdateAlertPopup =  true
  },
  userInfoAlertPopupClosedFun(){
    $('body').removeClass('body_right_scroll_remove')
    this.profileUpdateAlertPopup =  false
  },
  pdfViewerFun(url, fileName){
    this.pdfViewerFileName = fileName
    this.pdfViewerUrl = url
    this.pdfViewerPopup = true
    $('body').addClass("pdf_view_actv")
  },
  enabledJoinBtn(joinStartTime, joinEndTime) {
    var currentLocalDate = moment().format('MMMM Do YYYY');
    var currentLocalTime = moment().format('HH:mm:ss');
    var startDateCheck = moment(joinStartTime).format('MMMM Do YYYY')
    var startTimeCheck = moment(joinStartTime).format('HH:mm:ss')
    var endTimeCheck = moment(joinEndTime).format('HH:mm:ss')
    if(startDateCheck === currentLocalDate){
      if (currentLocalTime > startTimeCheck && endTimeCheck > currentLocalTime){
        return true;
      }else{   
        return false;
      }
    }else{
      return false;
    }
  },
  statusCheckOfWebinar(startTime){
    var curentDateUTC = moment().format();
    if (startTime > curentDateUTC){
      return true;
    }else{   
      return false;
    }
  },
  startCountdownTimer(joinStartTime,joinEndTime){
    var currentLocalDate = moment().format('MMMM Do YYYY');
    var startDateCheck = moment(joinStartTime).format('MMMM Do YYYY')
    var currentLocalHours = moment().format('HH')
    var currentLocalTime = moment().format('mm:ss')
    var currentLocalSec = moment().format('ss')
    var startTimeHours = moment(joinStartTime).format('HH')
    var startTimeCheck = moment(joinStartTime).format('mm:ss')
    var startTimeSec = moment(joinStartTime).format('mm:ss')
    if(startDateCheck === currentLocalDate){
        var totalMinutesOfStartMeeting  = startTimeHours*parseInt(60) + parseInt(startTimeCheck) + parseInt(15);
        var totalMinutesOfCurrent  = currentLocalHours*parseInt(60) + parseInt(currentLocalTime);
        if(totalMinutesOfStartMeeting > totalMinutesOfCurrent){
          var validTime = totalMinutesOfStartMeeting - totalMinutesOfCurrent
          // console.log(validTime, "Checking Hours to Mint")
          if(parseInt(30) > validTime){
            this.counterText = validTime + ':' + '00';
            this.countdownTimer()
            return this.counterText;
          }else{
            return false;
          }
        }else{
          return false;
        }
    }else{
      return false;
    }
    // var currentLocalDate = moment().format('MMMM Do YYYY');
    // var startDateCheck = moment(joinStartTime).format('MMMM Do YYYY')
    // var currentLocalHours = moment().format('HH')
    // var currentLocalTime = moment().format('mm:ss')
    // var currentLocalSec = moment().format('ss')
    // var startTimeHours = moment(joinStartTime).format('HH')
    // var startTimeCheck = moment(joinStartTime).format('mm:ss')
    // var startTimeSec = moment(joinStartTime).format('mm:ss')
    // if(startDateCheck === currentLocalDate){
    //   if(currentLocalHours === startTimeHours){
    //     var startTimeIncreasedCheck  = parseInt(startTimeCheck)  + parseInt(15);
    //     if(startTimeIncreasedCheck > parseInt(currentLocalTime)){
    //       var validTime = parseInt(startTimeIncreasedCheck) - parseInt(currentLocalTime)
    //       if(parseInt(30) > validTime){
    //         this.counterText = validTime + ':' + '00';
    //         // console.log(startTimeIncreasedCheck, validTime)
    //         this.countdownTimer()
    //         return this.counterText;
    //       }else{
    //         return false;
    //       }
    //     }else{
    //       return false;
    //     }
    //   }else{
    //     return false;
    //   }
    // }else{
    //   return false;
    // }
  },
  getCurrentDateWithUTC() {
    var CurrentHourFormat = this.curentDate.getHours();
    var CurrentMinutesFormat = this.curentDate.getMinutes();
    var CurrentSecondFormat = this.curentDate.getSeconds();
    this.fullCurrentDateFormatWithUtc = CurrentHourFormat + "-" + CurrentMinutesFormat
    this.countDownMinutes = CurrentMinutesFormat
    this.countDownSecond = CurrentSecondFormat
  },
  countdownTimer() {
    var __self = this
    clearInterval(interval);
    interval = setInterval( function() {
        var timer = $('.js-timeout').html();
        timer = timer.split(':');
        var minutes = timer[0];
        var seconds = timer[1];
        seconds -= 1;
        if (minutes < 0) return;
        else if (seconds < 0 && minutes != 0) {
            minutes -= 1;
            seconds = 59;
        }
        else if (seconds < 10 && length.seconds != 2) seconds = '0' + seconds;
        $('.js-timeout').html(minutes + ':' + seconds);
        if (minutes == 0 && seconds == 0){
          window.location.reload()
          clearInterval(interval)
        };
    }, 1000);
  },
  updateWebinarPopupMethod(id){
    this.updateWebinarPopup = true
    this.updateWebinarId = id
    $('body').addClass('body_right_scroll_remove')
  },
  createWebinarPopupMethod(){
    this.createWebinarPopup = true
    $('body').addClass('body_right_scroll_remove')
  },
  showSpeakerBioPopup(data){
    this.speakerBioPoup = true
    this.speakerBioData = data
    $('body').addClass('body_right_scroll_remove')
    var __self = this
    $(document).click(function (event) {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
      if (!$(event.target).closest(".speaker_popup_link,.speaker_bio_popup_modal_center").length) {
        __self.speakerBioPoup=false
        $('body').removeClass('body_right_scroll_remove')
      }
    });
  },
  hideSpeakerBioPopup(){
    this.speakerBioPoup=false
    $('body').removeClass('body_right_scroll_remove')
  },
},
watch: {
  getUserDetailsInfo(){
    return this.$store.getters.selfUserInfoGetters
  },
  getWebinarList() {
    return this.$store.getters.getWebinarAllListGetters
  },
},
beforeRouteLeave: function(to, from, next) {
  $('body').removeClass('body_right_scroll_remove')
  next();
},
beforeDestroy() {
  clearInterval(interval);
},
}